import type {
	VerificationStatus,
	WorklogEntryType,
} from "@/common/artemis-sdk";
import { TaskStatus } from "@/common/model";
import {
	createLabelTag,
	createStatusBadge,
	type TagStatus,
} from "../status-pill";

export const TaskVerificationStatusColorMap: Record<
	VerificationStatus,
	TagStatus
> = {
	PENDING: "warning",
	PASSED: "success",
	FAILED: "error",
};

export const TaskVerificationStatusLabelMap: Record<
	VerificationStatus,
	string
> = {
	PENDING: "Pending",
	PASSED: "Passed",
	FAILED: "Failed",
};

export const WorkLogentryTypeLabelMap: Record<WorklogEntryType, string> = {
	AGENT_OUTPUT: "Agent Output",
	SYSTEM: "System",
	USER_INPUT: "User Input",
};

export const TaskStatusColorMap: Record<TaskStatus, TagStatus> = {
	APPROVAL_REQUIRED: "warning",
	CANCELLED: "error",
	COMPLETED: "success",
	CREATED: "default",
	FAILED: "error",
	INPUT_REQUIRED: "warning",
	SUBMITTED: "warning",
	UNKNOWN: "default",
	WAITING: "warning",
	WORKING: "processing",
};

export const TaskStatusLabelMap: Record<TaskStatus, string> = {
	APPROVAL_REQUIRED: "Approval Required",
	CANCELLED: "Cancelled",
	COMPLETED: "Completed",
	CREATED: "Created",
	FAILED: "Failed",
	INPUT_REQUIRED: "Input Required",
	SUBMITTED: "Submitted",
	UNKNOWN: "Unknown",
	WAITING: "Waiting",
	WORKING: "Working",
};

export const TaskStatusBadge = createStatusBadge(
	TaskStatusColorMap,
	TaskStatusLabelMap,
	{
		pulseWhen: [TaskStatus.WORKING],
	},
);

export const WorklogTypeBadge = createLabelTag(WorkLogentryTypeLabelMap);

const VerificationStatusColorMap: Record<VerificationStatus, TagStatus> = {
	PENDING: "warning",
	PASSED: "success",
	FAILED: "error",
};

const VerificationStatusLabelMap: Record<VerificationStatus, string> = {
	PENDING: "Pending",
	PASSED: "Passed",
	FAILED: "Failed",
};

export const VerificationStatusBadge = createStatusBadge(
	VerificationStatusColorMap,
	VerificationStatusLabelMap,
);

const TaskVerificationStatusBadgeRequired = createStatusBadge(
	TaskVerificationStatusColorMap,
	TaskVerificationStatusLabelMap,
);

export function TaskVerificationStatusBadge({
	status,
}: {
	status?: VerificationStatus;
}) {
	return status ? (
		<TaskVerificationStatusBadgeRequired status={status} />
	) : null;
}
